module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"topicsListEmpty":"暂时没有符合条件的专题"},"zh_hk":{"topicsListEmpty":"暫時沒有符合條件的專題"},"en":{"topicsListEmpty":"There are currently no eligible topics"},"ja":{"topicsListEmpty":"現在、対象となるトピックはありません"}}')
  delete Component.options._Ctor
}
